var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 10 1.66675C5.39762 1.66675 1.66666 5.39771 1.66666 10.0001C1.66666 14.6025 5.39762 18.3334 10 18.3334Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.357 13.5356L6.46441 7.64301C6.13914 7.31774 6.13914 6.78977 6.46441 6.4645C6.78968 6.13923 7.31765 6.13923 7.64292 6.4645L13.5355 12.3571C13.8607 12.6823 13.8607 13.2103 13.5355 13.5356C13.2102 13.8608 12.6822 13.8608 12.357 13.5356Z",
    fill: "#474B53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46447 12.3571L12.357 6.4645C12.6823 6.13923 13.2103 6.13923 13.5355 6.4645C13.8608 6.78977 13.8608 7.31774 13.5355 7.64301L7.64298 13.5356C7.31771 13.8608 6.78974 13.8608 6.46447 13.5356C6.1392 13.2103 6.1392 12.6823 6.46447 12.3571Z",
    fill: "#474B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithBack);
export default __webpack_public_path__ + "static/media/close-with-back.7d1a9ee471c1974050d4653a89b9544a.svg";
export { ForwardRef as ReactComponent };